import { Box, Popover, useToggle } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import SendEmailReminderModal from 'modules/attendance/components/SendEmailReminderModal'
import type { ClockInStatus } from 'modules/attendance/pages/CustomPeriodsPage'

import ListContent from './ListContent'
import ListPopover from './ListPopover'

interface Props {
  clockInStatus: ClockInStatus
}

const AttendanceItem = ({ clockInStatus }: Props) => {
  const [open, toggle] = useToggle(false)
  const togglePopover = toggle(!open)
  const [emailReminderModalOpen, toggleEmailReminderModalOpen] = useToggle(false)

  const handleToggleWithTracking = (): void => {
    track(trackingEvents.timeTracking.seeRealTimeAttendanceTooltip, {
      from: 'page',
    })
    togglePopover()
  }

  if (!clockInStatus.employee) {
    throw new Error('Employee not found')
  }

  return (
    <Box cursor="pointer" width="fit-content">
      <Popover.ItemList
        attachment="bottom center"
        targetAttachment="top center"
        open={open}
        toggle={() => () => handleToggleWithTracking()}
        className="whoisin"
      >
        <ListContent
          employeeFullName={clockInStatus.employee.fullName}
          employeeAvatar={clockInStatus.employee.access.avatar ?? ''}
          status={clockInStatus.status ?? 'invalid_status'}
          onClick={togglePopover}
        />
        <ListPopover
          employeeId={clockInStatus.employee.id}
          togglePopover={togglePopover}
          toggleEmailReminderModalOpen={toggleEmailReminderModalOpen}
          showButtons={false}
        />
      </Popover.ItemList>
      {emailReminderModalOpen && (
        <SendEmailReminderModal
          employeeId={clockInStatus.employee.id}
          employeeFullName={clockInStatus.employee.fullName}
          onClose={toggleEmailReminderModalOpen(false)}
        />
      )}
    </Box>
  )
}

export default AttendanceItem
